import React, { FC } from 'react';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getComputedCSSVariable } from '../../../../utils/cssVariableHelpers';

interface Props {
  title: string;
  onClose(): void;
}

const ModalHeader: FC<Props> = ({ title, onClose }) => {
  return (
    <div className="modal-header">
      <h3 className="title">{title}</h3>
      <FontAwesomeIcon
        className="close-button"
        color={getComputedCSSVariable('message-black')}
        onClick={onClose}
        icon={faClose}
      />
    </div>
  );
};

export default ModalHeader;
